<div class="declaracao-saude-container">
  <!-- TERMO principal do documento -->
  <h3
    class="titulo text-center bold-preto-700 mb-1"
    style="padding: 0.5rem; background: black; color: #fff; border-radius: 10px">
    PROPOSTA DE ADESÃO MEDSÊNIOR
  </h3>
  <div class="documento-conteudo">
    <p class="paragrafo-inicial">
      Pelo presente instrumento, solicito a minha adesão e dos dependentes por mim relacionados, como
      <strong>BENEFICIÁRIO</strong>
      do
      <strong>CONTRATO DE PLANO DE SAÚDE</strong>
      , firmado em
      <span>01/06/2026</span>
      , entre a administradora de benefícios
      <strong>ADMSERV BENEFÍCIOS E SERVIÇOS LTDA</strong>
      de nome fantasia
      <strong>Géia Administradora de Benefícios</strong>
      , registrada na Agência Nacional de Saúde Suplementar-ANS, sob o número 416932, inscrita no CNPJ/MF sob o nº
      07.867.825/0001-57, com sede à Av. Valdemar Ferreira, 463 - Butantã, São Paulo - SP, CEP: 05501-000, doravante
      denominado
      <strong>ESTIPULANTE</strong>
      e a operadora de planos de saúde
      <strong>SAMEDIL – SERVIÇOS DE ATENDIMENTO MÉDICO S.A</strong>
      registrada na Agência Nacional de Saúde Suplementar-ANS sob o número 335614 e no CNPJ/MF sob nº
      31.466.949/0001-05, situada no endereço registrado na Receita Federal e representada na forma de seus atos
      constitutivo, denominada
      <strong>CONTRATADA</strong>
      , em razão do vínculo de caráter profissional, classista ou setorial que possuo com a Entidade de Classe, citada
      no anverso desta proposta, denominada
      <strong>ENTIDADE ADERENTE</strong>
      .
    </p>

    <!-- Cláusulas numeradas -->
    <div class="clausulas-container">
      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">1.</span>
          Para formalização da presente adesão, o
          <strong>BENEFICIÁRIO</strong>
          declara que recebeu ou teve acesso, previamente à assinatura, ao Termo de Adesão, ao Manual de Orientação para
          Contratação de Planos de Saúde – MPS, ao Guia de Leitura Contratual – GLC, à Declaração de Saúde e às
          condições gerais do contrato coletivo por adesão, declarando ciência de seu conteúdo.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">2.</span>
          O
          <strong>BENEFICIÁRIO</strong>
          declara ciência de que o plano de saúde será administrado, em seus aspectos cadastrais, financeiros e de
          relacionamento administrativo, pelo
          <strong>ESTIPULANTE</strong>
          , cabendo à
          <strong>CONTRATADA</strong>
          , com exclusividade, a responsabilidade pelos aspectos assistenciais do plano, incluindo rede credenciada,
          cobertura, regulação, autorizações e prestação dos serviços de saúde.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">3.</span>
          As inclusões de
          <strong>BENEFICIÁRIOS DEPENDENTES</strong>
          deverão ser solicitadas pelo
          <strong>BENEFICIÁRIO TITULAR</strong>
          junto ao
          <strong>ESTIPULANTE</strong>
          , observadas as regras contratuais, regulatórias, documentais e operacionais aplicáveis, inclusive quanto à
          elegibilidade, prazos de processamento, vigência e eventual incidência de carências.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">4.</span>
          Nos casos de filho adotivo ou cônjuge/companheiro, quando admitidos contratualmente, o pedido deverá ser
          formulado no prazo de 30 (trinta) dias contados do evento, para que tenha as condições previstas no contrato
          coletivo por adesão e na regulamentação aplicável, para fins de eventual aproveitamento de carências,
          observados os requisitos de elegibilidade e a apresentação da documentação pertinente.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">5.</span>
          Para solicitar a exclusão de beneficiários dependentes ou o cancelamento de sua adesão, o
          <strong>BENEFICIÁRIO TITULAR</strong>
          deverá formalizar o pedido pelos canais disponibilizados pelo
          <strong>ESTIPULANTE</strong>
          , observada a regulamentação da ANS vigente à época, produzindo efeitos nos prazos e condições legalmente
          aplicáveis, a partir da confirmação do recebimento e processamento da solicitação.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">6.</span>

          <strong>BENEFICIÁRIO TITULAR</strong>
          compromete-se a efetuar pontualmente o pagamento da mensalidade, em seu nome e de seus dependentes, com
          vencimento no dia 1º (primeiro) para clientes com vigência no dia 1º e no dia 15 (quinze) para clientes com
          vigência no dia 15, mediante débito em conta corrente, conforme as condições vigentes e autorizadas na
          proposta de adesão.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">7.</span>
          Afirma o
          <strong>BENEFICIÁRIO TITULAR</strong>
          ter ciência de que na hipótese de impontualidade no pagamento da mensalidade serão cobrados juros de mora de
          1% (um por cento) ao mês, calculados proporcionalmente ao tempo de atraso, além de multa moratória de 2% (dois
          por cento) incidente sobre o valor do débito atualizado.
        </p>
      </div>

      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="dataVigencia"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">8.</span>
          Declara o
          <strong>BENEFICIÁRIO TITULAR</strong>
          possuir completo conhecimento de que os valores das mensalidades serão reajustados conforme a sinistralidade
          apurada, bem como na ocasião de mudança de faixa etária, na forma prevista pelo
          <strong>CONTRATO DE PLANO DE SAÚDE</strong>
          celebrado entre
          <strong>ESTIPULANTE</strong>
          e a
          <strong>CONTRATADA</strong>
          e também prevista no
          <strong>MANUAL DE ORIENTAÇÃO PARA CONTRATAÇÃO DE PLANO DE SAÚDE - MPS</strong>
          .
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">9.</span>
          Declara o
          <strong>BENEFICIÁRIO TITULAR</strong>
          ter conhecimento de que poderá ser excluído do presente contrato em caso de perda da elegibilidade e nos casos
          de inadimplemento, caracterizado pelo atraso no pagamento de suas contribuições, conforme data previamente
          acordada. O atraso no pagamento poderá ensejar na suspensão da cobertura assistencial do BENEFICIÁRIO TITULAR
          inadimplente e de seus dependentes a ele vinculados, observadas as disposições regulatórias vigentes e
          mediante prévia notificação pelos meios admitidos neste contrato, sendo assegurado prazo para regularização do
          débito. Uma vez realizada a quitação integral do débito pelo beneficiário suspenso, a CONTRATANTE comunicará a
          CONTRATADA, devendo o restabelecimento da cobertura ocorrer no prazo máximo de 48 (quarenta e oito) horas a
          contar do efetivo recebimento da solicitação. Na hipótese de permanência da inadimplência, poderá ocorrer a
          exclusão do BENEFICIÁRIO TITULAR e de seus dependentes, caso haja atraso equivalente a duas mensalidades,
          consecutivas ou não, no período de 12 (doze) meses, desde que previamente cientificado por meio de correio
          eletrônico (e-mail), aplicativos que permitam a troca de mensagens criptografadas e a confirmação de
          recebimento e leitura pelo destinatário (como WhatsApp, Messenger ou outro do tipo), ligações gravadas (de
          forma pessoal ou pelo sistema URA), SMS e/ou carta com aviso de recebimento, , sendo concedido prazo mínimo de
          10 (dez) dias para regularização.
        </p>
        <div class="paragrafo">
          <p class="paragrafo-texto">
            <span class="paragrafo-numero">§ 1°:</span>
            Em caso de cancelamento ou exclusão do plano, poderá ocorrer a exclusão do
            <strong>BENEFICIÁRIO TITULAR</strong>
            e de seus dependentes, sem prejuízo da cobrança dos valores em aberto, acrescidos dos encargos contratuais e
            legais.
          </p>
        </div>
        <div class="paragrafo">
          <p class="paragrafo-texto">
            <span class="paragrafo-numero">§2°:</span>
            Permanecendo o inadimplemento, o
            <strong>ESTIPULANTE</strong>
            poderá adotar os meios legais cabíveis para cobrança do débito, inclusive, quando juridicamente admissível,
            o encaminhamento para protesto ou inscrição em cadastros de proteção ao crédito.
          </p>
        </div>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">10.</span>
          O
          <strong>BENEFICIÁRIO</strong>
          afirma ter ciência que também será excluído do plano de saúde em casos de fraude, declaração de informações
          falsas, incompletas ou omissões, como também na hipótese de utilização indevida do cartão de identificação, ou
          seja, se vier a autorizar terceiros a utilizar o seu cartão de identificação para realização de quaisquer
          procedimentos, sem prejuízo do
          <strong>ESTIPULANTE</strong>
          e da
          <strong>CONTRATADA</strong>
          adotarem as medidas judiciais cabíveis para se ressarcir dos danos sofridos.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">11.</span>
          O
          <strong>BENEFICIÁRIO TITULAR</strong>
          declara ciência de que, ressalvadas as hipóteses de manutenção previstas em lei, regulamentação ou contrato,
          sua exclusão do plano implicará a exclusão de seus dependentes a ele vinculados.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">12.</span>
          O
          <strong>BENEFICIÁRIO</strong>
          declara ciência de que a prestação dos serviços assistenciais, incluindo rede credenciada, coberturas,
          autorizações, regulação, procedimentos, internações e atendimentos médicos, hospitalares e ambulatoriais são
          de responsabilidade exclusiva da
          <strong>CONTRATADA</strong>
          e de seus prestadores.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">13.</span>
          O
          <strong>BENEFICIÁRIO</strong>
          outorga ao
          <strong>ESTIPULANTE</strong>
          , procuração, para que a mesma possa representá-lo e a seus dependentes perante a
          <strong>CONTRATADA</strong>
          e Agência Nacional de Saúde Suplementar (ANS), no cumprimento das cláusulas previstas no
          <strong>CONTRATO DE PLANO DE SAÚDE</strong>
          .
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">14.</span>
          Será disponibilizado ao
          <strong>BENEFICIÁRIO TITULAR</strong>
          e seus
          <strong>DEPENDENTES</strong>
          o
          <strong>CARTÃO DE IDENTIFICAÇÃO</strong>
          em formato digital (virtual), em tempo hábil para usufruto do plano de saúde, sendo sua disponibilização de
          inteira responsabilidade da
          <strong>CONTRATADA</strong>
          . A confecção e expedição de cartão físico somente ocorrerão mediante solicitação expressa do
          <strong>BENEFICIÁRIO</strong>
          , estando sujeitas à cobrança no valor de R$ 10,00 (dez reais) por unidade. Quaisquer omissões ou erros nas
          informações constantes no cartão virtual ou físico deverão ser imediatamente comunicados à
          <strong>ESTIPULANTE</strong>
          , para as devidas providências. Na hipótese de exclusão de dependentes ou cancelamento da adesão, o
          <strong>BENEFICIÁRIO</strong>
          ficará responsável pelo descarte do cartão físico eventualmente emitido, não sendo aplicável a devolução para
          cartões virtuais.
        </p>
      </div>
      <app-header-documento-final-proposta
        [entidadeProposta]="entidadeProposta"
        [razaoSocialEntidade]="razaoSocialEntidade"
        [codigoProposta]="codigoProposta"
        [vigenciaProposta]="dataVigencia"
        [operadoraVM]="operadoraVM"
        [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">15.</span>
          O descumprimento das obrigações previstas neste instrumento, no contrato coletivo por adesão ou o uso indevido
          do cartão e dos serviços do plano poderá ensejar a adoção das medidas administrativas, contratuais e judiciais
          cabíveis pelo
          <strong>ESTIPULANTE</strong>
          e/ou pela
          <strong>CONTRATADA</strong>
          , inclusive para ressarcimento de prejuízos comprovadamente suportados.
        </p>
      </div>

      <div class="clausula">
        <p class="clausula-texto">
          <span class="clausula-numero">16.</span>
          O
          <strong>ESTIPULANTE/ADMINISTRADORA</strong>
          atua exclusivamente na administração cadastral, financeira e operacional do plano coletivo por adesão, não
          integrando a prestação direta dos serviços assistenciais, os quais são de responsabilidade exclusiva da
          <strong>CONTRATADA</strong>
          .
        </p>
      </div>
    </div>

    <!-- Declaração final -->
    <div class="rodape-sem-quebra">
      <p class="texto-rodade">
        Declaro ter lido e estar de acordo com os itens acima, declaro ter lido o Manual de Orientação para Contratação
        do Plano de Saúde (MPS), cópia da Proposta de Adesão e da Declaração de Saúde, parte integrante deste documento
        e à disposição do beneficiário na área logada. Declaro ainda estar ciente de que o cartão de identificação do
        beneficiário será disponibilizado, preferencialmente, em formato digital (virtual), no inicio da sua vigência
        contratual.
      </p>
      <div class="texto-rodade-assinatura rodape-sem-quebra assinatura-container">
        <app-assinatura-documento
          [nomeTitular]="nomeBeneficiario || '-'"
          [dataAssinatura]="dataAssinatura"
          [horaAssinatura]="horaAssinatura"
          [nomeCorretora]="nomeCorretora"
          [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
      </div>
    </div>
  </div>

  <!-- PERGUNTAS INCIO -->
  <div class="documento-conteudo">
    <!-- perguuntas -->
    <div class="declaracao-saude-medsenior" *ngIf="beneficiarios && beneficiarios.length > 0">
      <!-- Iterar sobre cada beneficiário -->
      <div class="beneficiario-container" *ngFor="let beneficiario of beneficiarios; let i = index">
        <app-header-documento-final-proposta
          [entidadeProposta]="entidadeProposta"
          [razaoSocialEntidade]="razaoSocialEntidade"
          [codigoProposta]="codigoProposta"
          [vigenciaProposta]="dataVigencia"
          [operadoraVM]="operadoraVM"
          [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>

        <!-- dados altura e peso inicio -->
        <div class="col-md-12 col-md-12-tablet">
          <p><strong>Indique no quadro o peso e altura</strong></p>
          <div class="table-responsive">
            <table class="table custom-table tabela-impressao-compacta">
              <thead>
                <tr>
                  <th style="background: #ccc"></th>
                  <th style="background: #ccc">Titular</th>
                  <th style="background: #ccc" *ngFor="let dep of colunasDependentes; let i = index">
                    Dep {{ i + 1 }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- LINHA PESO -->
                <tr>
                  <td class="text-center"><b>Peso</b></td>
                  <td class="text-center">{{ obterPesoPorBeneficiario(beneficiarioTitular) || '' }}</td>
                  <td class="text-center" *ngFor="let dep of dependentesList">
                    {{ obterPesoPorBeneficiario(dep) || '' }}
                  </td>
                </tr>

                <!-- LINHA ALTURA -->
                <tr>
                  <td class="text-center"><b>Altura</b></td>
                  <td class="text-center">{{ obterAlturaPorBeneficiario(beneficiarioTitular) || '' }}</td>
                  <td class="text-center" *ngFor="let dep of dependentesList">
                    {{ obterAlturaPorBeneficiario(dep) || '' }}
                  </td>
                </tr>

                <!-- LINHA S/N (mostra se tem alguma doença declarada) -->
                <!-- <tr>
          <td class="text-center"><b>S/N</b></td>
          <td class="text-center">{{ temDoencaDeclarada(beneficiarioTitular) ? 'S' : 'N' }}</td>
          <td class="text-center" *ngFor="let dep of dependentesList">
            {{ temDoencaDeclarada(dep) ? 'S' : 'N' }}
          </td>
        </tr> -->

                <!-- LINHA PATOLOGIA (mostra as doenças) -->
                <!-- <tr>
          <td class="text-center"><b>Patologia</b></td>
          <td class="text-center">
            <span *ngIf="temDoencaDeclarada(beneficiarioTitular)">
              {{ obterPatologias(beneficiarioTitular) }}
            </span>
            <span *ngIf="!temDoencaDeclarada(beneficiarioTitular)" style="color: #999">—</span>
          </td>
          <td class="text-center" *ngFor="let dep of dependentesList">
            <span *ngIf="temDoencaDeclarada(dep)">
              {{ obterPatologias(dep) }}
            </span>
            <span *ngIf="!temDoencaDeclarada(dep)" style="color: #999">—</span>
          </td>
        </tr> -->
              </tbody>
            </table>

            <!-- OBSERVAÇÃO -->
            <div
              class="mb-3"
              style="
                margin-top: 15px;
                padding: 10px;
                background: #f5f5f5;
                border-left: 4px solid #333;
                font-size: 0.9rem;
              ">
              <p>
                <strong>
                  DEVERÁ SER PREENCHIDA OBRIGATORIAMENTE PELO BENEFICIÁRIO TITULAR EM CASO DE PREENCHIMENTO POSITIVO
                  (SIM), INFORMAR A(S) PATOLOGIA(S) DO(S) RESPECTIVO ITEM.
                </strong>
              </p>
              <p><strong>PREENCHER COM "S" = SIM ou "N" = NÃO</strong></p>
            </div>
          </div>
        </div>
        <!-- dados altura e peso fim -->

        <!-- <pre>{{ beneficiario | json }}</pre> -->
        <!-- dados altura e peso fim -->
        <h4 class="nome-beneficiario">
          {{ beneficiario.name }}
          <span
            class="badge"
            [class.badge-titular]="!beneficiario.dependentProposalId"
            [class.badge-dependente]="beneficiario.dependentProposalId">
            {{ !beneficiario.dependentProposalId ? 'TITULAR' : 'DEPENDENTE' }}
          </span>
        </h4>

        <div class="table-responsive">
          <div class="table-responsive">
            <table class="table table-bordered text-center">
              <thead>
                <tr>
                  <th class="col-prefixo">#</th>
                  <th class="col-pergunta">É PORTADOR DE:</th>
                  <th class="col-resposta">Se aplica</th>
                </tr>
              </thead>
              <tbody>
                <!-- Usando o novo método que ordena corretamente -->
                <tr
                  *ngFor="let item of obterPerguntasOrdenadas(beneficiario); let idx = index"
                  [class.row-comum]="item.tipo === 'Comum'"
                  [class.row-campo-livre]="item.tipo === 'CampoLivre'"
                  [class.row-info-adicional]="item.tipo === 'InformacoesAdicionais'"
                  [class.row-sim]="item.seAplica === true">
                  <!-- Prefixo (número) -->
                  <td class="col-prefixo">
                    <span
                      *ngIf="
                        item.tipo === 'Comum' || item.tipo === 'CampoLivre' || item.tipo === 'InformacoesAdicionais'
                      ">
                      {{ item.ordem }}
                    </span>
                  </td>

                  <!-- Pergunta -->
                  <td class="col-pergunta">
                    <span class="pergunta-texto">{{ item.pergunta }}</span>

                    <!-- Detalhamento do beneficiário (se houver) -->
                    <div
                      style="font-weight: 600 !important"
                      class="detalhamento-beneficiario"
                      *ngIf="item.seAplica && item.detalhamento">
                      <span class="detalhamento-label">Detalhamento informado pelo beneficiário:</span>
                      <span class="detalhamento-texto">{{ item.detalhamento }}</span>
                    </div>
                  </td>

                  <!-- Resposta (SIM/NÃO) -->
                  <td class="col-resposta">
                    <span
                      class="resposta-badge"
                      [class.resposta-sim]="item.seAplica"
                      [class.resposta-nao]="!item.seAplica">
                      {{ item.seAplica ? 'SIM' : 'NÃO' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- TERMO DE CIENCIA INICIO-->
        <div class="documento-conteudo mt-2" style="margin-top: -24px">
          <p class="paragrafo-inicial">
            Tenho ciência que, exercendo prerrogativa legal, a Operadora não fornecerá a opção pelo Agravo que é
            qualquer acréscimo no valor da contraprestação paga ao plano privado de assistência à saúde, para que o
            beneficiário tenha direito integral à cobertura contratada, para a doença ou lesão preexistente declarada,
            após os prazos de carências contratuais, de acordo com as condições negociadas entre a operadora e o
            beneficiário.
          </p>
          <p class="mt-2 paragrafo-inicial" style="margin-top: -18px !important">
            Tenho ciência de meu direito de ser orientado no preenchimento dessa declaração de saúde, sem ônus
            financeiro, por um médico indicado pela operadora, ou de optar por um profissional de minha livre escolha
            assumindo o ônus financeiro desta opção.
          </p>
        </div>
        <!-- TERMO DE CIENCIA FIM-->

        <!-- TERMO DE ACEITACAO INICIO -->
        <div class="documento-conteudo border-info-main mt-2">
          <h5 class="orientacao-titulo bold preto">TERMO DE ACEITAÇÃO DE CPT – COBERTURA PARCIAL TEMPORÁRIA</h5>

          <p class="paragrafo-inicial mt-1">
            Declaro que em virtude das respostas afirmativas na Declaração de Saúde sobre doenças ou lesões
            preexistentes que possuo neste momento, a SAMEDIL, atendendo à Resolução Normativa 558/2022 e suas
            alterações, ofertou-me a CPT – Cobertura Parcial Temporária, que é aquela que admite, por um período
            ininterrupto de até 24 meses, a partir da data da contratação ou adesão ao plano privado de assistência à
            saúde, a suspensão da cobertura de Procedimentos de Alta Complexidade (PAC), leitos de alta tecnologia e
            procedimentos cirúrgicos, desde que relacionados exclusivamente às doenças ou lesões preexistentes
            declaradas pelo beneficiário ou seu representante legal, tendo eu optado por aceitar essa restrição de
            cobertura para o meu plano de saúde.
          </p>

          <!-- CIDS INICIO -->
          <div *ngIf="temCidsSelecionados(beneficiario)" class="sem-cids" style="margin-top: 22px !important">
            <div class="documento-conteudo border-info-main mt-2">
              <h5 class="orientacao-titulo bold preto">
                DOENÇAS OU LESÕES PREEXISTENTES COM COBERTURA PARCIAL TEMPORÁRIA - CPT
              </h5>
              <ng-container *ngFor="let item of ordenarPerguntasPorTipo(beneficiario.declaracaoSaudeFormatada)">
                <div class="mt-2" *ngIf="item.cidsSelecionados && item.cidsSelecionados.length > 0">
                  <div class="cids-cpt-item" *ngFor="let cid of item.cidsSelecionados">
                    <strong>{{ cid.descricao }}[{{ cid.cid }}]</strong>
                    - Observação: {{ cid.descricao }}
                  </div>
                  <!-- <div class="detalhamento-cpt" *ngIf="item.detalhamento">Observação: {{ item.detalhamento }}</div> -->
                </div>
              </ng-container>
            </div>
          </div>
          <!-- CIDS   FIM -->

          <!-- DECLRACAO INICIO -->
          <div class="cpt-section" *ngIf="hasCptDeclaracao(beneficiario)">
            <div class="cpt-item" *ngFor="let cpt of filtrarPerguntasPorTipo(beneficiario, 'Cpt')">
              <div class="cpt-checkbox">
                <span class="checkbox-x" *ngIf="cpt.seAplica">X</span>
              </div>
              <div class="cpt-texto">{{ cpt.pergunta }}</div>
            </div>
          </div>
          <!-- DECLARACAO FIM -->
        </div>
        <!-- TERMO DE ACEITACAO FIM -->

        <!-- SEÇÃO ORIENTAÇÃO MÉDICA -->
        <div class="orientacao-section" *ngIf="hasOrientacaoMedica(beneficiario)">
          <h5 class="orientacao-titulo">Condições do preenchimento da declaração de saúde</h5>
          <div class="orientacao-item" *ngFor="let orient of filtrarPerguntasPorTipo(beneficiario, 'OrientacaoMedica')">
            <div class="orientacao-checkbox">
              <span class="checkbox-x" *ngIf="orient.seAplica">X</span>
            </div>
            <div class="orientacao-texto">{{ orient.pergunta }}</div>
          </div>
        </div>

        <!-- Loading State -->
        <div class="loading-state" *ngIf="!beneficiarios || beneficiarios.length === 0">
          <p>Carregando dados de avaliação de saúde...</p>
        </div>
        <!-- perguntas -->
        <!-- Declaração de Saúde MedSenior -->
        <div class="assinatura-container">
          <app-assinatura-documento
            [nomeTitular]="nomeBeneficiario || '-'"
            [dataAssinatura]="dataAssinatura"
            [horaAssinatura]="horaAssinatura"
            [nomeCorretora]="nomeCorretora"
            [nomeVendedor]="nomeVendedor"></app-assinatura-documento>
        </div>
      </div>
    </div>
  </div>

  <!-- PERGUNTAS FIM -->
</div>
